import { css } from 'linaria';

export const image = css`
  max-width: 100%;
  max-height: 100%;
  object-fit: cover;
`;
